import BlockFormatNormalizationsPluginFactory from '../Blocks/BlockFormatNormalizationsPluginFactory';

const ParagraphNormalizationsPlugin =
  BlockFormatNormalizationsPluginFactory('paragraph');

export default ParagraphNormalizationsPlugin;
